<div class="col no-padding font-medium d-flex align-items-center justify-content-start mt-3 mb-3">
  <div (click)="addEditNewFolder(null, 1)" [ngClass]="{'disabled-control':!canEdit}" class="w-100 add-root-btn">
    <i class="fa fa-plus mr-2"></i>
    Add New Root Folder
  </div>
</div>
<ngx-treeview [config]="config" [itemTemplate]="itemTemplate" [items]="items"></ngx-treeview>
<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
  let-onCheckedChange="onCheckedChange">
  <div [ngClass]="{ selected: selectedItem?.value == item.value?.id }"
    class="form-inline row-item justify-content-between">
    <span (click)="folderSelect(item)" class="d-flex">
      <i (click)="
          $event.preventDefault(); $event.stopPropagation(); onCollapseExpand()
        " *ngIf="item.children" aria-hidden="true" [ngSwitch]="item.collapsed">
        <svg *ngSwitchCase="true" width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-right-fill"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
        </svg>
        <span *ngSwitchCase="true" class="ml-2">
          <i aria-hidden="true" class="fa fa-folder mr-2"></i>
        </span>
        <svg *ngSwitchCase="false" width="0.8rem" height="0.8rem" viewBox="0 0 16 16" class="bi bi-caret-down-fill"
          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
        </svg>
        <span *ngSwitchCase="false" class="ml-2">
          <i aria-hidden="true" class="fa fa-folder-open mr-2"></i>
        </span>
        <div *ngIf="item?.value && item?.value?.count" class="children-count"></div>
      </i>
      <span class="form-check w-100">
        <span *ngIf="!item.children" class="form-check-label ml-2">
          <i aria-hidden="true" class="fa fa-folder mr-2"></i>
        </span>
        <div *ngIf="!item.children && item?.value && item?.value?.count" class="children-count"></div>
        <label [ngClass]="{ 'parent-folder': item.children }" class="form-check-label folder-labels"
          title="{{ item.text }}" (click)="item.checked = !item.checked; onCheckedChange()">
          {{ item.text }}
          <span class="ml-2" *ngIf="item?.value && item?.value?.count">
            ({{ item.value.count }})
          </span>
        </label>
      </span>
    </span>
    <span class="menu" ngbDropdown container="body">
      <span ngbDropdownToggle>
        <i class="fa fa-ellipsis-v mr-2"></i>
      </span>
      <span ngbDropdownMenu>
        <label><small><b class="ml-3 text-muted folder-labels menu-folder-labels">{{
              item.text
              }}</b></small></label>
        <button *ngIf="!item?.collapsed || item?.children" ngbDropdownItem (click)="addEditNewFolder(item, 1)">
          Add Sub-Folder
        </button>
        <button ngbDropdownItem (click)="addEditNewFolder(item, 2)">
          Rename
        </button>
        <div *ngIf="!item?.children && item?.value?.count < 1" class="dropdown-divider"></div>
        <button *ngIf="!item?.children && item?.value?.count < 1" ngbDropdownItem (click)="deleteFolder(item)">
          Delete
        </button>
      </span>
    </span>
  </div>
</ng-template>